import { CustomerAddressCard } from "@/services/backend/addresses/components/customer-address-card";
import { ServiceAddressCard } from "@/services/backend/addresses/components/service-address-card";
import { ContactCard } from "@/services/backend/contacts/components/contact-card";
import { RepresentativeCard } from "@/services/backend/representatives/components/representative-card";
import { useConfirmationContext } from "@/routes/processes/[processId]/htz/confirmations/[confirmationId]/_components/confirmation-context";
import { Address } from "@/services/backend/addresses/types/address";
import { Contact } from "@/services/backend/contacts/types/contact";
import { Representative } from "@/services/backend/representatives/types/representative";
import {
  updateServiceContact,
  updatePostalAddress,
  updateRepresentative,
  updateServiceAddress,
} from "@/services/backend/htz/confirmations/types/confirmation";
import t from "@/lang/lang";
import {
  fieldErrorsForPrefix,
  resetField,
} from "@/shared/lib/errors/validation-error";

export function AddressesAndContactsRoute() {
  const {
    confirmation,
    onConfirmationChange,
    validationError,
    setValidationError,
  } = useConfirmationContext();

  const resetValidationErrorField = (prefix: string) => (field: string) => {
    const prefixedField = `${prefix}${field}`;
    setValidationError(resetField(validationError, prefixedField));
  };

  const onCustomerAddressChange = (customerAddress: Address) => {
    onConfirmationChange(updatePostalAddress(confirmation, customerAddress));
  };

  const onServiceAddressChange = (serviceAddress: Address) => {
    onConfirmationChange(updateServiceAddress(confirmation, serviceAddress));
  };

  const onServiceContactChange = (serviceContact: Contact) => {
    onConfirmationChange(updateServiceContact(confirmation, serviceContact));
  };

  const onRepresentativeChange = (representative: Representative) => {
    onConfirmationChange(updateRepresentative(confirmation, representative));
  };

  return (
    <div className="grid gap-2 xl:grid-cols-2">
      <CustomerAddressCard
        customerAddress={confirmation.postalAddress}
        onCustomerAddressChange={onCustomerAddressChange}
        description={t(
          "Adresse an welche das Auftragsbestätigung geschickt werden soll.",
        )}
        fieldErrors={fieldErrorsForPrefix(validationError, "postalAddress.")}
        resetFieldError={resetValidationErrorField("postalAddress.")}
        disabled={confirmation.immutable}
      />
      <ServiceAddressCard
        address={confirmation.serviceAddress}
        onAddressChange={onServiceAddressChange}
        fieldErrors={fieldErrorsForPrefix(validationError, "serviceAddress.")}
        resetFieldError={resetValidationErrorField("serviceAddress.")}
        disabled={confirmation.immutable}
      />
      <ContactCard
        contact={confirmation.serviceContact}
        onContactChange={onServiceContactChange}
        disabled={confirmation.immutable}
      />
      <RepresentativeCard
        representative={confirmation.representative}
        onRepresentativeChange={onRepresentativeChange}
        fieldErrors={fieldErrorsForPrefix(validationError, "representative.")}
        resetFieldError={resetValidationErrorField("representative.")}
        disabled={confirmation.immutable}
      />
    </div>
  );
}
